



























































import Vue from 'vue'
import Component from 'vue-class-component'
import Card from '@/components/Card.vue'
import TrackingMail from '@/components/TrackingMail.vue'
import { EStatementStatuses, IStatement, IStatementListFilterDTO } from '@zunta/configurations'
import { StatementModule } from '@/store/modules/statement.module'
import { getModule } from 'vuex-module-decorators'
import {
  DO_NOT_BILL_STATUSES,
  STATEMENT_MAILED_STATUSES,
  STATEMENT_STATUSES_LABEL_MAP,
  STATEMENTS_STORAGE_URL
} from '@/constants'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import Icon from '@/components/Icon.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import Table from '@/components/tables/Table.vue'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import StatusStatement from '@/components/statuses/StatusStatement.vue'
import DownloadModal from '@/views/app/management/mailings/components/DownloadModal.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { makeErrorNotification } from '@/utils/notification'

@Component({
  props: {
    minHeight: {
      type: String
    },
    maxHeight: {
      type: String
    }
  },
  components: {
    StatusStatement,
    Table,
    Icon,
    DateTimeLabel,
    TrackingMail,
    Card,
    LoaderWrapper,
    DownloadModal
  }
})
export default class ResidentStatements extends Vue {
  statementModuleInstance: StatementModule = getModule(StatementModule, this.$store)
  doNotBillStatuses: EStatementStatuses[] = DO_NOT_BILL_STATUSES
  EStatementStatuses: any = EStatementStatuses
  user: User = Api.getUser() as User
  showDownloadModal: boolean = false
  trackingStatement: IStatement | null = null
  isLoadMore: boolean = false
  isFirstLoad: boolean = false
  isLoading: boolean = false
  filters: any = {
    skip: 0,
    limit: 20
  }

  config: ITableConfig = {
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
      class: 'rounded-bottom'
    },
    useQuery: true,
    usePagination: true,
    rowClick: this.goStatementReview,
    fetchFunction: this.fetchStatements,
    maxHeight: this.$props.maxHeight,
    minHeight: this.$props.minHeight,
    columns: [
      {
        minWidth: '100px',
        width: 15,
        key: 'number',
        searchKey: 'number',
        hasSort: true,
        hasSearch: true,
        label: 'Batch Number',
        type: ETableColumnType.default
      },
      {
        minWidth: '120px',
        width: 15,
        key: 'createdAt',
        searchKey: 'billDate',
        hasSort: true,
        hasSearch: true,
        label: 'Statement Date',
        type: ETableColumnType.dateRange
      },
      {
        minWidth: '120px',
        width: 25,
        key: 'status',
        searchKey: 'status',
        hasSort: true,
        hasSearch: true,
        label: 'Mailing Status',
        type: ETableColumnType.select,
        options: this.statementStatusesFilter
      },
      {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '120px',
        width: 20,
        key: 'due',
        searchKey: 'due',
        hasSort: true,
        hasSearch: true,
        label: 'Due',
        type: ETableColumnType.numberRange
      },
      {
        minWidth: '120px',
        width: 20,
        key: 'updatedAt',
        searchKey: 'lastUpdate',
        hasSort: true,
        hasSearch: true,
        label: 'Update Date',
        type: ETableColumnType.dateRange
      },
      {
        class: 'text-right',
        minWidth: '50px',
        width: 5,
        key: 'actions',
        searchKey: 'actions',
        hasSort: false,
        hasSearch: false,
        type: ETableColumnType.default
      }
    ]
  }

  get residentId () {
    return this.$route.params.id
  }

  get statementList () {
    return this.$store.state.statement.statementList
  }

  get statementListTotal () {
    return this.$store.state.statement.statementListTotal
  }

  get statementStatusesFilter () {
    return [
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.RETURNED],
        key: EStatementStatuses.RETURNED,
        value: EStatementStatuses.RETURNED
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.EMAIL_RETURNED],
        key: EStatementStatuses.EMAIL_RETURNED,
        value: EStatementStatuses.EMAIL_RETURNED
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.NEEDS_FIX],
        key: EStatementStatuses.NEEDS_FIX,
        value: EStatementStatuses.NEEDS_FIX
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.NEEDS_REVIEW],
        key: EStatementStatuses.NEEDS_REVIEW,
        value: EStatementStatuses.NEEDS_REVIEW
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.READY_TO_MAIL],
        key: EStatementStatuses.READY_TO_MAIL,
        value: EStatementStatuses.READY_TO_MAIL
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.READY_TO_EMAIL],
        key: EStatementStatuses.READY_TO_EMAIL,
        value: EStatementStatuses.READY_TO_EMAIL
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.READY_TO_PRINT],
        key: EStatementStatuses.READY_TO_PRINT,
        value: EStatementStatuses.READY_TO_PRINT
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.DO_NOT_BILL],
        key: EStatementStatuses.DO_NOT_BILL,
        value: EStatementStatuses.DO_NOT_BILL
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.DO_NOT_BILL_NEGATIVE],
        key: EStatementStatuses.DO_NOT_BILL_NEGATIVE,
        value: EStatementStatuses.DO_NOT_BILL_NEGATIVE
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.DO_NOT_BILL_ZERO],
        key: EStatementStatuses.DO_NOT_BILL_ZERO,
        value: EStatementStatuses.DO_NOT_BILL_ZERO
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.DO_NOT_BILL_CONTROL],
        key: EStatementStatuses.DO_NOT_BILL_CONTROL,
        value: EStatementStatuses.DO_NOT_BILL_CONTROL
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.DO_NOT_BILL_PERMANENTLY],
        key: EStatementStatuses.DO_NOT_BILL_PERMANENTLY,
        value: EStatementStatuses.DO_NOT_BILL_PERMANENTLY
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.ALREADY_SENT],
        key: EStatementStatuses.ALREADY_SENT,
        value: EStatementStatuses.ALREADY_SENT
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.DELIVERED],
        key: EStatementStatuses.DELIVERED,
        value: EStatementStatuses.DELIVERED
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.REROUTED],
        key: EStatementStatuses.REROUTED,
        value: EStatementStatuses.REROUTED
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.IN_TRANSIT],
        key: EStatementStatuses.IN_TRANSIT,
        value: EStatementStatuses.IN_TRANSIT
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.IN_LOCALAREA],
        key: EStatementStatuses.IN_LOCALAREA,
        value: EStatementStatuses.IN_LOCALAREA
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.IN_PROCESS],
        key: EStatementStatuses.IN_PROCESS,
        value: EStatementStatuses.IN_PROCESS
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.PRINTED_LOCALLY],
        key: EStatementStatuses.PRINTED_LOCALLY,
        value: EStatementStatuses.PRINTED_LOCALLY
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.PROCESSED_FOR_DELIVERY],
        key: EStatementStatuses.PROCESSED_FOR_DELIVERY,
        value: EStatementStatuses.PROCESSED_FOR_DELIVERY
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.PENDING],
        key: EStatementStatuses.PENDING,
        value: EStatementStatuses.PENDING
      },
      {
        content: STATEMENT_STATUSES_LABEL_MAP[EStatementStatuses.EMAILED],
        key: EStatementStatuses.EMAILED,
        value: EStatementStatuses.EMAILED
      }
    ]
  }

  beforeDestroy () {
    this.statementModuleInstance.resetStatementList()
  }

  async fetchStatements (filters: IStatementListFilterDTO) {
    await this.statementModuleInstance.getResidentStatementListByFilters({
      residentId: this.residentId,
      filters
    })
  }

  mounted () {
    this.$eventBus.$on('downloading', this.downloadingStatus)
    this.$eventBus.$on('hasCorruptFiles', this.doMakeErrorNotification)
  }
  
  toggleDownload (show: boolean) {
    this.showDownloadModal = show
  }

  downloadingStatus (status: boolean) {
    this.isLoading = status
  }

  doMakeErrorNotification (message: string) {
    makeErrorNotification(this, message)
  }

  isMailed (status: EStatementStatuses) {
    return STATEMENT_MAILED_STATUSES.includes(status)
  }

  showTrackerIcon (statement: IStatement) {
    return !!statement.dateMailed
  }

  openTracker (statement: IStatement) {
    this.trackingStatement = statement
  }

  closeTrackStatement () {
    this.trackingStatement = null
  }

  goStatementReview (statement: IStatement) {
    if (this.user.isResident()) {
      window.open(`${STATEMENTS_STORAGE_URL}?file=${statement.pdf}`)
      return
    }

    const route = {
      name: 'review-statements',
      params: {
        batch: statement.batch.toString(),
        type: 'mailed',
        statement: statement.id.toString()
      }
    }

    if (!this.isMailed(statement.status)) {
      route.params.type = 'unmailed'
    }

    this.$locationManager.rememberAndGoTo(route)
  }
}
